import React from "react";
import { useTranslation } from "react-i18next";
import { Box } from "@mui/material";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import DirectionsCarOutlinedIcon from "@mui/icons-material/DirectionsCarOutlined";

function Count({ icon, value, label }) {
  return (
    <Box
      component="span"
      title={label}
      sx={{ display: "inline-flex", alignItems: "center", gap: 0.35 }}
    >
      {icon}
      {value}
    </Box>
  );
}

function BrokerAssetCounts({ stats }) {
  const { t } = useTranslation();
  const iconSx = { fontSize: 14 };

  return (
    <Box component="span" sx={{ display: "inline-flex", alignItems: "center", gap: 1 }}>
      <Count
        icon={<HomeOutlinedIcon sx={iconSx} />}
        value={stats.propertyCount}
        label={t("portfolioExplorer.stats.properties")}
      />
      <Count
        icon={<DirectionsCarOutlinedIcon sx={iconSx} />}
        value={stats.motorCount}
        label={t("portfolioExplorer.stats.motors")}
      />
      <Box component="span">
        · {t("portfolioExplorer.card.insuredEntities", { count: stats.combinedCount })}
      </Box>
    </Box>
  );
}

export default BrokerAssetCounts;
